import { Input, InputProps, forwardRef } from '@chakra-ui/react';

import { useClearableInputContext } from './use-clearable-input';

export const ClearableInput = forwardRef<InputProps, 'input'>((props, ref) => {
  const { getClearableInputFieldProps } = useClearableInputContext();
  return <Input {...getClearableInputFieldProps(props, ref)} />;
});
ClearableInput.id = 'Input';
